import { render, staticRenderFns } from "./JKUserInfo.vue?vue&type=template&id=392104e1&scoped=true&"
import script from "./JKUserInfo.vue?vue&type=script&lang=js&"
export * from "./JKUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./JKUserInfo.vue?vue&type=style&index=0&id=392104e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392104e1",
  null
  
)

export default component.exports